import { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useAppStore } from '@/hooks/useAppStore';
import { storeAdminAuthToken } from '@/lib/admin/auth';
import { LoaderCircle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

/**
 * Backend redirects to this page after OAuth success and an admin JWT token.
 */
export const AdminAuthCallbackPage = () => {
  const navigate = useNavigate();
  const setAdminUser = useAppStore((state) => state.setAdminUser);
  const { token } = useParams();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (token) {
      const user = storeAdminAuthToken(token);
      setAdminUser(user);
      const storedPath = searchParams.get("returnTo");
      if (storedPath) {
        navigate(storedPath);
      } else {
        navigate("/admin");
      }
    } else {
      console.error("URL parameter token is missing, redirecting to login");
      navigate("/admin-login");
    }
  }, [token]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-neutral-900 text-white">
      <Card className="w-full max-w-sm bg-neutral-800 border-neutral-700 text-white">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl font-thin uppercase tracking-[4px] text-chotto-gold">
            Chotto ゲスト
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-1">
          <div className="flex flex-col items-center justify-center">
            <div className="w-full text-center my-4" >
              <LoaderCircle className="inline-flex animate-spin w-4 h-4 mr-1" />
              Loading ...
            </div>
          </div>
        </CardContent>
      </Card>
    </div>);
};
